export default __webpack_public_path__ + "static/media/svg-1.443af13a.svg";